export class EventEmitter {
    constructor() {
        this.listeners = {};
    }
    on(event, callback) {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event].push(callback);
    }
    emit(event, ...args) {
        if (this.listeners[event]) {
            this.listeners[event].forEach(callback => {
                try {
                    callback(...args);
                }
                catch (e) {
                    console.error(e);
                }
            });
        }
    }
    remove(event, callback) {
        if (this.listeners[event]) {
            this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
        }
    }
}
export class EmitterBase {
    constructor() {
        this.eventEmitter = new EventEmitter();
    }
    addEventListener(event, callback) {
        this.eventEmitter.on(event, callback);
    }
    removeEventListener(event, callback) {
        this.eventEmitter.remove(event, callback);
    }
    emitEvent(event, ...args) {
        this.eventEmitter.emit(event, ...args);
    }
}
